import { ShieldCheck, UsersThree, Books } from "@phosphor-icons/react";
import { Reveal, Eyebrow } from "./Reveal";

const PRINCIPLES = [
  {
    icon: ShieldCheck,
    title: "Zero referral fees",
    body: "No kickbacks, commissions, or compensation from any company we discuss — no connection, no obligation, no quiet incentives. When we point you toward a company, it's because it's best for you, and for no other reason.",
  },
  {
    icon: UsersThree,
    title: "Staffed by owners & insiders",
    body: "Our team is made up of vacation owners and former employees of vacation ownership companies. We've owned the weeks, paid the fees, and sat on both sides of the sales desk.",
  },
  {
    icon: Books,
    title: "Transparency, without the fluff",
    body: "Education is the key, and we're the source. Every recommendation shows its working — the maths, the contract clauses, the complaint history — so you never have to take our word for anything.",
  },
];

export default function Independence() {
  return (
    <section id="independence" data-testid="independence-section" className="py-24 md:py-36 bg-secondary/40 border-y border-border">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl">
          <Eyebrow>Our Independence</Eyebrow>
          <h2 className="font-serif text-primary tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.08]" data-testid="independence-heading">
            No kickbacks. No quotas. <em className="text-accent">No one to please but you.</em>
          </h2>
          <p className="mt-6 text-foreground/70 max-w-xl leading-relaxed">
            The Timeshare Edit is a completely independent source. We accept nothing from the companies
            we write about — so the only interest we serve is yours.
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1} className="h-full">
              <div className="h-full bg-card border border-border rounded-sm p-8 hover:border-accent/60 hover:-translate-y-1 transition-[border-color,transform] duration-500" data-testid={`independence-card-${i}`}>
                <p.icon size={28} weight="duotone" className="text-accent" />
                <h3 className="font-serif text-2xl text-primary tracking-tight mt-5">{p.title}</h3>
                <p className="mt-3 text-sm text-foreground/65 leading-relaxed">{p.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
